import { Card, CardContent, Stack, Typography } from '@mui/material';
import { ErrorBoundary } from '@sentry/react';
import { useLocation } from 'react-router-dom';

import { SubpageLayout } from '@/components/architecture/Layout/SubpageLayout';
import { Button } from '@/components/form/baseInputs/Button';
import { DataTableCard } from '@/components/tables/DataTable/components/DataTableCard';
import { PageSizes } from '@/components/tables/DataTable/constants';
import { usePaginatedDataTableQuery } from '@/components/tables/DataTable/hooks/usePaginatedDataTableQuery';
import { useRequiredParam } from '@/hooks/useRequiredParam';
import { ActivityTable } from '@/modules/activities/ActivityTable/ActivityTable';
import { useGetActivityGroupsQuery } from '@/modules/activities/graphql/ActivityGroups.generated';

export function ClientActivityHistoryPage() {
  const householdId = useRequiredParam('householdId');
  const location = useLocation();
  const [paginatedTableProps, { data }] = usePaginatedDataTableQuery(
    useGetActivityGroupsQuery,
    {
      pageSize: PageSizes.Five,
      variables: {
        where: { hasHouseholdWith: [{ id: householdId }] },
      },
    }
  );

  return (
    <Stack height="100%" p={2}>
      <SubpageLayout heading="Activity history">
        <Stack height="100%">
          <ErrorBoundary
            key={location.pathname}
            fallback={() => (
              <Card sx={{ width: '100%' }}>
                <CardContent>
                  <Stack spacing={2} alignItems="flex-start">
                    <Typography variant="title-xs">
                      Activity history couldn&apos;t load
                    </Typography>
                    <Typography variant="body-xs">
                      There was an error loading the activity history. Please
                      try again.
                    </Typography>
                    <Button
                      variant="primary"
                      size="sm"
                      onClick={() => {
                        window.location.reload();
                      }}
                    >
                      Retry
                    </Button>
                  </Stack>
                </CardContent>
              </Card>
            )}
          >
            <DataTableCard>
              <ActivityTable data={data} {...paginatedTableProps} />
            </DataTableCard>
          </ErrorBoundary>
        </Stack>
      </SubpageLayout>
    </Stack>
  );
}
